import { b2cPolicies, loginRequest } from '../../../authConfig'
import { useLoyaltyStore } from '../loyaltyStore'

export const handleSignIn = async instance => {
  await instance.initialize()
  instance
    .loginRedirect(b2cPolicies.authorities.signInCustom, {
      ...loginRequest,
      prompt: 'login',
      extraQueryParameters: {
        max_age: '900'
      }
    })
    .catch(error => console.log(error))
}

export const handlePasswordChange = async instance => {
  await instance.initialize()
  instance
    .loginRedirect(b2cPolicies.authorities.passwordChange, {
      ...loginRequest,
      prompt: 'login',
      extraQueryParameters: {
        max_age: '900'
      }
    })
    .catch(error => console.log(error))
}

export const handleEmailChange = async instance => {
  await instance.initialize()
  instance
    .loginRedirect({
      authority: b2cPolicies.authorities.emailChange.authority,
      ...loginRequest,
      prompt: 'login',
      extraQueryParameters: {
        max_age: '900'
      }
    })
    .catch(error => console.log(error))
}

export const handleSignOut = async instance => {
  await instance.initialize()
  const logoutRequest = {
    // account: instance.getAccountByHomeId(homeAccountId),
    mainWindowRedirectUri: '/',
    postLogoutRedirectUri: '/'
  }
  useLoyaltyStore.getState().resetLoyaltyStore()
  instance.logoutRedirect(logoutRequest)
}
